import { supportedLocales } from 'as-ui-kit/const/strings';
import { Locale } from 'as-ui-kit/types';

import { getCookies } from './cookies';

const getLocaleFromCookies = (): Locale => {
    const DEFAULT_LOCALE = 'ru';
    const cookies = getCookies();
    const locale = cookies['uicult2'] as Locale;
    return locale || DEFAULT_LOCALE;
};

const getSupportedLocale = (locale = 'ru'): Locale => {
    return supportedLocales[locale as Locale] || 'ru';
};

export { getLocaleFromCookies, getSupportedLocale };
